"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceClass = void 0;
const typeorm_1 = require("typeorm");
const JournaledEntity_1 = require("../../JournaledEntity");
// eslint-disable-next-line import/no-cycle
const PriceUnit_1 = require("../../prices/entity/PriceUnit");
// eslint-disable-next-line import/no-cycle
const ServiceQualification_1 = require("./ServiceQualification");
let ServiceClass = class ServiceClass extends JournaledEntity_1.JournaledEntity {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.ServiceClass = ServiceClass;
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], ServiceClass.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], ServiceClass.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], ServiceClass.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => PriceUnit_1.PriceUnit),
    __metadata("design:type", PriceUnit_1.PriceUnit)
], ServiceClass.prototype, "defaultPriceUnit", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => PriceUnit_1.PriceUnit),
    (0, typeorm_1.JoinTable)(),
    __metadata("design:type", Array)
], ServiceClass.prototype, "usablePriceUnits", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sc) => sc.usablePriceUnits),
    __metadata("design:type", Array)
], ServiceClass.prototype, "usablePriceUnitIds", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => ServiceQualification_1.ServiceQualification, (sq) => sq.serviceClass, {
        cascade: ['insert', 'update']
    }),
    __metadata("design:type", Array)
], ServiceClass.prototype, "requiredQualifications", void 0);
exports.ServiceClass = ServiceClass = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Unique)(['name']),
    __metadata("design:paramtypes", [Object])
], ServiceClass);
